import Immutable from 'immutable';

export const GET_SOFT_DELETE = 'takeback/api/SOFT_DELETE';
export const GET_SOFT_DELETE_SUCCESS = 'takeback/api/SOFT_DELETE_SUCCESS';
export const GET_SOFT_DELETE_FAILURE = 'takeback/api/SOFT_DELETE_FAILURE';

export const UPDATE_PASSWORD = 'takeback/api/UPDATE_PASSWORD';
export const UPDATE_PASSWORD_SUCCESS = 'takeback/api/UPDATE_PASSWORD_SUCCESS';
export const UPDATE_PASSWORD_FAILURE = 'takeback/api/UPDATE_PASSWORD_FAILURE';

export const UPDATE_EMAIL = 'takeback/api/UPDATE_EMAIL';
export const UPDATE_EMAIL_SUCCESS = 'takeback/api/UPDATE_EMAIL_SUCCESS';
export const UPDATE_EMAIL_FAILURE = 'takeback/api/UPDATE_EMAIL_FAILURE';

const initialState = Immutable.OrderedMap();

// Reducers
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case GET_SOFT_DELETE_SUCCESS:
        return state.set('deleted', true).set('emailMismatch', false).set('error', null);
    case GET_SOFT_DELETE_FAILURE:
        return state.set('error', action.error.message).set('deleted', false).set('emailMismatch', !!action.error.emailMismatch);
    default:
        return state;
    }
}

export function getSoftDeleteSuccess(data) {
    return { type: GET_SOFT_DELETE_SUCCESS, data };
}

export function getSoftDeleteFailure(error) {
    return { type: GET_SOFT_DELETE_FAILURE, error };
}

export function updatePasswordSuccess(data) {
    return { type: UPDATE_PASSWORD_SUCCESS, data };
}

export function updatePasswordFailure(errors) {
    return { type: UPDATE_PASSWORD_FAILURE, errors };
}

export function updateEmailSuccess(data) {
    return { type: UPDATE_EMAIL_SUCCESS, data };
}

export function updateEmailFailure(errors) {
    return { type: UPDATE_EMAIL_FAILURE, errors };
}

